import {MitgliedDto} from '@wba/models/dto/mitglied-dto';

export class MitgliederDomainDto {
  mitglieder: MitgliedDto[] = [];
  bg = { hatKostenUnterkunft: undefined, hatUmzug: undefined, letzteBewilligung: '' };
}
